import { render, staticRenderFns } from "./Watch.vue?vue&type=template&id=4cfb067c&scoped=true&"
import script from "./Watch.vue?vue&type=script&lang=js&"
export * from "./Watch.vue?vue&type=script&lang=js&"
import style0 from "./Watch.vue?vue&type=style&index=0&id=4cfb067c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb067c",
  null
  
)

export default component.exports